import { createSelector } from '@ngrx/store';

const selectProfileList = (state: any) => state.profileList;

// Base selector to access profile lists state
const selectCountriesState = createSelector(
  selectProfileList,
  (profileLists) => profileLists.profileLists
);

// Selector to get the list of countries
export const selectProfileLists = createSelector(
  selectCountriesState,
  (profileListsState) => profileListsState.profileLists
);

// Selector to check if the operation was successful
export const selectProfileListsSuccess = createSelector(
  selectCountriesState,
  (profileListsState) => profileListsState
);

// Selector to get any errors from operations
export const selectProfileListsFailure = createSelector(
  selectCountriesState,
  (profileListsState) => profileListsState.error
);
